// React and related imports
import { useEffect, useState } from 'react';

// Redux selectors, hooks, and actions
import { useAppSelector } from '../redux/hooks/useAppSelector';
import {
  selectIsContentContextModalOpen,
  selectSelectedContentContext,
} from '../redux/selectors/contentContextSelectors';

// Types and Interfaces
import { Status } from '../common/enums/Status';
import { IContentContext } from '../common/interfaces/ContentContext.interface';
import { IMultiLanguageValue } from '../common/interfaces/MultiLanguageValue.interface';
import { PrayerName } from '../common/enums/PrayersName';
import { WeekDays } from '../common/enums/WeekDays';

export type ContextState = IContentContext | null;

interface UseContentContextStateReturn {
  isModalOpen: boolean;
  contextState: ContextState;
  updateField: (
    field: keyof IContentContext,
    value:
      | null
      | string
      | Status
      | boolean
      | PrayerName
      | WeekDays[]
      | IMultiLanguageValue[]
  ) => void;
}

export const useContentContextState = (): UseContentContextStateReturn => {
  const isModalOpen = useAppSelector(selectIsContentContextModalOpen);
  const selectedContext = useAppSelector(selectSelectedContentContext);

  const [contextState, setContextState] = useState<ContextState>(null);

  useEffect(() => {
    // Update the context state whenever selectedContext changes
    setContextState(selectedContext);
  }, [selectedContext]);

  const updateField = (
    field: keyof IContentContext,
    value:
      | null
      | string
      | Status
      | boolean
      | PrayerName
      | WeekDays[]
      | IMultiLanguageValue[]
  ) => {
    setContextState((prev) => ({
      ...prev!,
      [field]: value,
    }));
  };

  return { isModalOpen, contextState, updateField };
};
